 
     <app-slider></app-slider>
     <app-slider-mobile></app-slider-mobile>
     <app-secciones-principales></app-secciones-principales>   
     <app-secciones-destacadas></app-secciones-destacadas>
     <app-blog-home></app-blog-home>
     <app-banner-destacado></app-banner-destacado>
     <app-cotizacion></app-cotizacion>
     